import axios from 'axios';
import Vue from 'vue';

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

axios.interceptors.response.use(
  (r) => r, (error) => {
    const message = error.response && error.response.data && (error.response.data.errors && error.response.data.errors.message || error.response.data.message) || error.message;
    Vue.toasted.show(message, {
      position: 'bottom-right', type: 'error', icon: 'warning', duration: 5000, keepOnHover: true,
      action: {
        text: 'Chiudi',
        onClick(e, toastObject) {
          toastObject.goAway(0);
        }
      }
    });
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axios;
